/* @flow */
/*global $, _gaq*/
/*eslint camelcase: [2, {properties: "never"}]*/

$(function () {
    "use strict";
    var processGoToSwatches = processGoToSwatches;

    processGoToSwatches();

    $(".measurement_sizechart").find("tbody").find("tr:lt(2)").find("th, td").addClass('strong-border-top');

    function processGoToSwatches() {
        if (Modernizr.sessionstorage) {
            if(sessionStorage.getItem("goToSwatches") !== null) {
                sessionStorage.removeItem("goToSwatches");
                $.smoothScroll({
                    scrollElement: $('body'),
                    scrollTarget: '#material_swatch_area'
                });
            }
        }
    }

    //if the php has added a material swatch area to the page, enable swatch functionality
    if ($("#material_swatch_area").length) {
        $("[data-action=\"add-swatch\"]").click(function () {
            var button = $(this);
            $.post("/ajax_add_swatch_to_basket.php", {product_id: $(this).attr("rel")}, function (data) {
                if (data.added === true) {
                    button.removeClass("btn-primary").addClass("btn-success");
                    button.val("View Basket");
                    button.unbind("click");
                    button.click(function (e) {
                        e.preventDefault();
                        location.href = "https://" + window.location.host + "/basket.php";
                    });
                    $("#swatch_goto_basket").css("display", "block");
                    $("#header_basket_qty").html("(" + data.total_qty + ")");
                    $(".basket-total").html(data.total);
                }
            }, "json");
        });
    }

    //measurement sizechart
    var toggleUnits = $(".toggle_units");
    var isImperial = toggleUnits.attr("data-imperial");
    $("body").on("click", ".toggle_units", function (e) {
        e.preventDefault();
        if (isImperial) {
            $(".inch").hide();
            $(".cm").show();
            $(".toggle_units").text('Click for Inches');
        } else {
            $(".inch").show();
            $(".cm").hide();
            $(".toggle_units").text('Click for Centimetres');
        }

        isImperial = !isImperial;
        toggleUnits.attr("data-imperial", isImperial);
    });

    $('a[href^="#"]').smoothScroll();
    $('.smoothscroll').smoothScroll();
});
